







































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import MailingListJson from "../../shared/MailingListJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateMailingListJson, validateMailingListJsonAdd } from "../../shared/MailingListJson";

export default Vue.extend({
  name: "MailingsListDetails",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    mailingListId: Number,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      allMailingLists: null as MailingListJson[] | null,
      selectedMailingListId: null as number | null,
      mailingListDetails: null as MailingListJson | null,
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<MailingListJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initMailingListDetails();
  },
  mounted() {},
  methods: {
    initMailingListDetails() {
      this.selectedMailingListId = this.mailingListId;

      this.loadMailingLists();
      this.loadMailingListDetails();

      this.selectDetailsMode(this.mode);
    },

    async loadMailingLists() {
      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadMailingListDetails() {
      if (this.selectedMailingListId != null) {
        if (this.restClient != null) {
          try {
            this.mailingListDetails = await this.restClient.getMailingList(this.selectedMailingListId);
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.mailingListDetails = this.getDefaultMailingListData();
      }

      this.hasChanges = false;
    },

    reloadDetailsView() {
      if (this.selectedMailingListId != null) {
        this.mailingListDetails = null;

        this.loadMailingListDetails();
      } else {
        this.closeDetails();
      }
    },

    getDefaultMailingListData() {
      return {
        ID: null,
        name: "",
        isSignUpPublic: false,
      };
    },

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Empfänger:in hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Empfänger:in bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Empfänger:in";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.reloadDetailsView();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.reloadDetailsView();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.mailingListDetails != null) {
        this.validation = validateMailingListJson(this.mailingListDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async addNewMailingList() {
      if (this.mailingListDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        this.validation = validateMailingListJsonAdd(this.mailingListDetails);

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.mailingListDetails = await this.restClient.addMailingList(this.mailingListDetails);
            alert("Liste wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Liste konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveMailingListDetails() {
      if (this.mailingListDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateMailingListJson(this.mailingListDetails);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedMemberDetails = await this.restClient.updateMailingList(this.mailingListDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteMailingList() {
      if (this.selectedMailingListId != null) {
        let c = confirm("Wollen Sie diese Liste wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteMailingList(this.selectedMailingListId);
              this.closeDetails();
              alert("Liste wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },
  },

  watch: {
    mailingListDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
